import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p8ncnjxwk2: FaireBrandEntity = {
  token: "b_p8ncnjxwk2",
  type: "brand",
  name: "Pure Good",
  avatarUrl:
    "https://cdn.faire.com/fastly/bb82bbc477fcc6c1879a0485445f5864b1a76acbad261f0d9fee40627112f20d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5600b29e114ba9438171bea9dbfc809e6a7b949548b3888e2450b688702676ab.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bb82bbc477fcc6c1879a0485445f5864b1a76acbad261f0d9fee40627112f20d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5600b29e114ba9438171bea9dbfc809e6a7b949548b3888e2450b688702676ab.jpeg",
  location: "Wichita, KS, USA",
  minimumOrderDollars: 416,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "As 6th generation ranchers, we care greatly about the sustainability of our planet and the quality of life of our cattle. We wanted no part of our animals to go to waste, and we were seeing that many people discard the fat from their cattle. We believe in taking the parts of the animals that would normally be wasted, and helping them live to their full potential.\n\nThat's where our tallow comes in. Handcrafted, small-batch tallow balm made from grass fed cattle raised on our very own family ranch. Each batch is made by hand from start to finish and combined with specifically selected essential oils to nourish, moisturize, and heal your skin. Tallow is the sustainable skincare that's been used for centuries and is currently skyrocketing in popularity. Not only is it clean skincare that works, but you can feel good about the ingredients you're using.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:41.308Z",
    importedBy: "entity-db-cli",
  },
};
